module.exports = __webpack_public_path__ + "static/media/ico_simulation_eye_periocular.cf461e0b.png";